// src/components/common/Button.jsx
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  primary = false, 
  onClick, 
  className = '', 
  type = 'button',
  to = null // Add this prop
}) => {
  // If "to" prop exists, render as Link
  if (to) {
    return (
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Link
          to={to}
          className={`inline-block px-6 py-3 rounded-full font-medium transition-colors ${
            primary 
              ? 'bg-primary text-white hover:bg-gray-700' 
              : 'bg-dark-gray text-white hover:bg-gray-700'
          } ${className}`}
        >
          {children}
        </Link>
      </motion.div>
    );
  }
  
  // Otherwise render as button
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`px-6 py-3 rounded-full font-medium transition-colors ${
        primary 
          ? 'bg-primary text-white hover:bg-gray-700' 
          : 'bg-dark-gray text-white hover:bg-gray-700'
      } ${className}`}
      onClick={onClick}
      type={type}
    >
      {children}
    </motion.button>
  );
};

export default Button;
